import React, { CSSProperties } from 'react';

interface RoomsProps {
  detailListStyle: CSSProperties,
  roomsTotal: number | undefined,
  bedroomsTotal: number | undefined,
}

const Rooms = ({detailListStyle, roomsTotal, bedroomsTotal} : RoomsProps) => {
	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-bed-alt me-2" />
        Rooms
			</p>
			<ul style={detailListStyle}>
				{roomsTotal && roomsTotal > 0 && <li><span className="cc-font-weight--normal">Rooms Total:</span> {roomsTotal && roomsTotal > 0 ? roomsTotal : 'None Listed'}</li>}
				{<li><span className="cc-font-weight--normal">Bedrooms:</span> {bedroomsTotal || 'None Listed'}</li>}
			</ul>
		</React.Fragment>
	);
};

export default Rooms;
